import Image from "next/image";
import DetailDiagnosisFin from "./Fin";
import DetailDiagnosisMomentum from "./momentum";
import DetailDiagnosisSharpe from "./Sharpe";
import { useParams } from "next/navigation";
import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import useHandleImageError from "utils/useHandleImageError";
import SkeletonBlock from "components/skeleton";
import DetailAlarmRegister from "./DetailAlarmRegister";
import { useSession } from "next-auth/react";
import { useEffect, useMemo, useState } from "react";
import { AlarmProvider } from "../../Header/Buttons/Index";
import { motion, AnimatePresence } from "framer-motion";
import CustomToast from "components/atoms/CustomToast";
function DiagnosisIndex({
  scoreData,
  detailData,
  alarmAnimationInit,
  setAlarmAnimationInit,
}: {
  scoreData: any;
  detailData: any;
  alarmAnimationInit: boolean;
  setAlarmAnimationInit: (value: boolean) => void;
}) {
  const { ticker } = useParams();
  const router = useRouter();
  const { t } = useTranslation("detail");
  const totalPercent = scoreData?.TOTAL_PER;
  const handleImageError = useHandleImageError();
  const [alarmSuccessToastVisible, setAlarmSuccessToastVisible] =
    useState<any>();
  const { data: session }: any = useSession();
  const isAlarmRegistered = useMemo(() => {
    if (session && session.user) {
      return session.user.alarm.includes(ticker);
    }
  }, [session, ticker]);

  if (!detailData) return null;

  return (
    <div className="pb-9">
      <div>
        <AlarmProvider detailData={detailData}>
          {() => {
            return (
              <div className="relative">
                <AnimatePresence mode="wait">
                  {!isAlarmRegistered ? (
                    <motion.div
                      key="alarm-register"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{
                        duration: 0.3,
                        ease: "easeInOut",
                      }}
                    >
                      <DetailAlarmRegister
                        score={scoreData?.TOTAL_PER}
                        init={alarmAnimationInit}
                        setInit={setAlarmAnimationInit}
                        isAlarmRegistered={isAlarmRegistered}
                        setAlarmSuccessToastVisible={
                          setAlarmSuccessToastVisible
                        }
                        detailData={detailData}
                      />
                    </motion.div>
                  ) : (
                    <motion.div
                      key="diagnosis-index"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{
                        duration: 0.3,
                        ease: "easeInOut",
                      }}
                      className="fixed bottom-[22px] left-[50%] translate-x-[-50%] z-[2] "
                      id="diagnosis-index"
                    >
                      {scoreData ? (
                        <div className="rounded-[30px] bg-white border border-blue20 px-3 py-[6px]">
                          <p className={`${TYPO.TYPO7_1_MD} text-gray70`}>
                            {t("investmentAttractiveness")}{" "}
                            <span className={`${TYPO.TYPO7_1_MD} text-blue40`}>
                              {t("scorePoints", {
                                score: scoreData?.TOTAL_PER,
                              })}
                            </span>
                          </p>
                        </div>
                      ) : (
                        // <div className="bg-gray2 rounded-[14px] flex flex-col border border-gray15 overflow-hidden">
                        //   <div className="p-4 flex gap-3 items-center">
                        //     <Image
                        //       unoptimized
                        //       quality={100}
                        //       alt="img"
                        //       height={40}
                        //       width={40}
                        //       src={`https://kr.object.ncloudstorage.com/riskweather-public/logos/${ticker}.png`}
                        //       style={{
                        //         borderRadius: "12px",
                        //         objectFit: "cover",
                        //         width: "48px",
                        //         height: "48px",
                        //       }}
                        //       onError={(event) => handleImageError(event, "")}
                        //       priority={true}
                        //     />
                        //     <div className="flex flex-col grow">
                        //       <p className={`${TYPO.TYPO7_1_MD} text-gray60`}>
                        //         {router.locale === "ko"
                        //           ? "투자매력도 종합"
                        //           : "Total"}
                        //       </p>
                        //       <p className={`${TYPO.TYPO6_SB} text-gray80`}>
                        //         {scoreData?.TOTAL_PER}
                        //         {router.locale === "ko" ? "점" : ""}
                        //       </p>
                        //     </div>
                        //   </div>
                        // </div>
                        <SkeletonBlock width={"100%"} height={81} radius={10} />
                      )}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          }}
        </AlarmProvider>
        <CustomToast
          successIconFill={"#34BB7A"}
          message={
            isAlarmRegistered ? t("alarmRegisteredSms") : undefined
          }
          isVisible={alarmSuccessToastVisible && isAlarmRegistered}
          onClose={() => {
            console.log("onClose");
            setAlarmSuccessToastVisible(false);
          }}
          width={router.locale === "ko" ? 245 : 275}
          duration={3000}
          customAnimation="bottom-toast-detail-alarm-register"
        />
      </div>

      <DetailDiagnosisMomentum
        score={scoreData?.MOM_PER}
        base_dt={scoreData?.m_BASE_DT}
        detailData={detailData}
      />
      <DetailDiagnosisSharpe
        score={scoreData?.RAR_PER}
        base_dt={scoreData?.s_BASE_DT}
        detailData={detailData}
      />
      <DetailDiagnosisFin
        score={scoreData?.FIN_SCORE}
        base_dt={scoreData?.f_REPT_PERIOD}
        detailData={detailData}
      />
    </div>
  );
}

export default DiagnosisIndex;
